// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/confirm-dialog-create-task/confirm-dialog-create-task.component.css"],"names":[],"mappings":";AACA;GACG,wBAAwB;AAC3B","sourcesContent":["\n::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
